import type { Component, InjectionKey, Ref } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

export const defaultHomeRouteInjectionKey = Symbol(
    'freya-layout-default-home-route'
) as InjectionKey<Ref<RouteLocationRaw>>;

export const userProfileComponentInjectionKey = Symbol(
    'freya-layout-user-profile-component'
) as InjectionKey<Component | null>;
